import { useDispatch } from "../../../redux/hooks";
import { Button } from "../../../components/shared/Button/Button";
import { IconRefresh, IconRestore } from "@tabler/icons-react";
import { setNMEAModalData } from "../../../redux/slices/generatorFeaturesSlice";
import { StyledTd } from "../../../styled";
import useCellProps from "../../PortraitOrientation/Row/useCellProps";

interface Props {
  rowIndex: number;
  sectionIndex: number;
  hidden?: boolean;
  width?: string;
  rowSpan?: number;
}
const NMEARefreshButton = ({
  rowIndex,
  sectionIndex,
  hidden = false,
  width,
  rowSpan,
}: Props) => {
  const { propGetter } = useCellProps(hidden);

  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(
      setNMEAModalData({
        opened: true,
        triggeredBy: "refresh",
        rowIndex,
        sectionIndex,
      }),
    );
  };
  return (
    <StyledTd
      rowSpan={rowSpan ?? 1}
      valign={rowSpan && rowSpan > 1 ? "middle" : undefined}
      {...propGetter({ width: width ?? "auto" })}
      center>
      <Button onClick={handleClick} style={{ margin: "0 auto" }} size="xs">
        <IconRefresh size="18" />
      </Button>
    </StyledTd>
  );
};
export default NMEARefreshButton;
